<template>
  <div class="page">
      <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: "Leistungen",
 metaInfo: {
    title: 'Wir fertigen Ihr Produkt nach Wunsch',
    meta:[
      { vmid: 'description', name: 'description', content: "Naturstein im Innen- und Außenbereich erfreut sich einer immer stärkeren Beliebtheit. Ob als Natursteinboden, Naturstein Küchenarbeitsplatte oder in Form von Granit Treppen."},
      { vmid: 'keywords', name: 'keywords', content: "Naturstein Küchenarbeitsplatten, Natursteinboden, Natursteintreppen, Naturstein Bad, Naturstein Tische, Naturstein Theken,Naturstein Mönchengladbach"},
      
    ],
    links: [ {rel: 'canonical', href: 'https://www.marmor-kunze.de/leistungen'} ]
  },
  mounted(){
  }
};
</script>
j
<style>
</style>



// WEBPACK FOOTER //
// src/components/views/Leistungen.vue